const SEEN_KEY = 'jc-follow-email-prompt-seen';

/**
 * The follow → email-updates offer is shown at most once per browser
 * (localStorage, not session): it fires right after a follow succeeds, and
 * repeating it on every follow would turn a nudge into a nag. A user who
 * ignored it can still enable alert emails any time from the Alerts page,
 * and a fresh browser only re-prompts if the subscription still isn't active
 * (the caller checks that first).
 */
export function hasSeenFollowEmailPrompt(): boolean {
  try {
    return localStorage.getItem(SEEN_KEY) === '1';
  } catch {
    // Storage unavailable (SSR, privacy mode) — err on not prompting.
    return true;
  }
}

export function markFollowEmailPromptSeen(): void {
  try {
    localStorage.setItem(SEEN_KEY, '1');
  } catch {
    // Best effort only.
  }
}
